import {translations as refundStatuses} from '@/helpers/orderRefundStatuses'

export default function () {
  return {
    // 'form' | 'pix' | 'done' | 'manual'
    step: 'form',
    amount: 0,
    refund: null,
    confirmVisible: false,
    errorMessage: null,
    pixTimerId: null,
    pixCodeCopied: false,
    refundStatuses
  }
}
